import { defineMessages } from 'react-intl'

const scope = `procurify.components.SavedFilterManagerSaveButton`

export default defineMessages({
  saveFiltersButtonText: {
    id: `${scope}.saveFiltersButtonText`,
    defaultMessage: 'Save filters',
  },
})
